import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper";

export default class extends Controller {
  static get targets() {
    return [
      "noResultState", "recipientCheckbox", "toggleAllCheckbox", "selectionSample", "selectionSampleContainer",
      "selectionSampleLoader", "selectionSubmit", "addRecipientsChoice", "addRecipientsFromLeads",
      "addRecipientsManually", "addRecipientsModal", "audienceActions",
      "recipientsSelectedCount", "manualInputField", "btnLabelText",
      "noResultStateMessage", "leadsForm"
    ]
  }

  static get values() {
    return {
      csvImportUrl: String
    }
  }

  initialize() {
    // Those are default filters when opening leads selector.
    // We want to steer users into contacting only never contacted leads.
    this.filters = { sending_status: ["~"] }

    var _this = this

    // Reinitialize the content of the popup when closed
    App.modalEvent($(this.addRecipientsModalTarget), "hide.bs.modal", function () {
      setTimeout(() => {
        _this.resetAddRecipientsPopup()
      }, 1000)
    })
  }

  addFiltersToForm() {
    Object.keys(this.filters).forEach((filter_name) => {
      let values = this.filters[filter_name]
      TempFormHelper.addHiddenInput(this.leadsFormTarget, "filters_type", "leads")

      if (Array.isArray(values) && filter_name !== "sync_status") {
        values.forEach((value) => {
          TempFormHelper.addHiddenInput(this.leadsFormTarget, `campaign[leads_filters][${filter_name}][]`, value)
        })
      } else if (filter_name === "sync_status") {
        TempFormHelper.addHiddenInput(this.leadsFormTarget, `campaign[leads_filters][${filter_name}]`, values.join("|"))
      } else {
        TempFormHelper.addHiddenInput(this.leadsFormTarget, `campaign[leads_filters][${filter_name}]`, values)
      }
    })
  }

  // displayLeadsSample uses all the filters defined by the user and updates
  // the Turbo.frame with the updated leads sample.
  displayLeadsSample() {
    this.displayLoader()

    try {
      // Build the correct URL with current filters
      const params = this.getLeadsAPIRequestParameters()
      this.selectionSampleTarget.src = `/campaigns/leads_sample?${params}`
      this.selectionSampleTarget.reload()

      this.selectionSampleTarget.loaded.then(() => {
        this.hideLoader()

        let btnTextLabel = document.getElementById("selection-submit-label")
        // Handle case where the element might not exist
        if (!btnTextLabel) {
          console.warn("Could not find selection-submit-label element")
          this.selectionSubmitTarget.setAttribute("disabled", "disabled")
          return
        }

        let leadsCount = btnTextLabel.dataset.leadsCount
        let leadsTotal = btnTextLabel.dataset.leadsTotal

        // Update submit button text
        this.selectionSubmitTarget.textContent = btnTextLabel.textContent
        if (leadsCount > 0) {
          this.selectionSubmitTarget.removeAttribute("disabled")
        } else {
          this.displayNoResultState(leadsTotal)
        }
      }).catch(error => {
        console.error("Error loading leads sample:", error)
        this.hideLoader()
        this.selectionSubmitTarget.setAttribute("disabled", "disabled")
      })
    } catch (error) {
      console.error("Error in displayLeadsSample:", error)
      this.hideLoader()
      this.selectionSubmitTarget.setAttribute("disabled", "disabled")
    }
  }

  displayLoader() {
    $(this.selectionSampleContainerTarget).hide()
    $(this.selectionSampleLoaderTarget).show()
  }

  hideLoader() {
    $(this.selectionSampleLoaderTarget).hide()
    $(this.selectionSampleContainerTarget).show()
  }

  displayNoResultState(total) {
    // In case of empty selection, we give a different tip depending on the situation
    if ($(".filter-block.selected .close-filter").length > 0 && total > 5) {
      $(this.noResultStateMessageTarget).text(i18n.t("js.back.campaigns.audience.no_leads_found_with_filters"))
    } else {
      $(this.noResultStateMessageTarget).html(i18n.t("js.back.campaigns.audience.no_leads_found_html", { path: "/leads_imports/new", btn_class: "h-button h-button--primary", class: "far fa-upload" }))
    }

    $(this.selectionSubmitTarget).attr("disabled", "disabled")
  }

  hideNoResultState() {
    $(this.noResultStateTarget).hide()
    $(this.selectionSubmitTarget).removeAttr("disabled")
  }

  // getLeadsAPIRequestParameters returns the parameters that will be used
  // to get all the leads based on filters defined by the user.
  getLeadsAPIRequestParameters() {
    let parameters = new URLSearchParams()

    Object.keys(this.filters).forEach((filter) => {
      let values = this.filters[filter]

      if (filter === "sync_status" || filter === "country_code") {
        parameters.append(filter, values.join("|"))
      } else if (Array.isArray(values)) {
        values.forEach((value) => {
          parameters.append(filter + "[]", value)
        })
      } else {
        parameters.append(filter, values)
      }
    })

    return parameters.toString()
  }

  showImportFromLeads() {
    App.analytics.track("Import recipients from leads")

    $(this.addRecipientsModalTarget).find(".modal-dialog").addClass("modal-lg")
    $(this.addRecipientsChoiceTarget).hide()
    $(this.addRecipientsFromLeadsTarget).show()
    this.displayLeadsSample()
  }

  csvUpload() {
    App.analytics.track("Import recipients from CSV")

    Turbo.visit(this.csvImportUrlValue)
  }

  showImportManually() {
    App.analytics.track("Import recipients from manual paste")

    $(this.addRecipientsChoiceTarget).hide()
    $(this.addRecipientsManuallyTarget).show()
    $(this.manualInputFieldTarget).focus()
  }

  resetAddRecipientsPopup() {
    $(this.addRecipientsChoiceTarget).show()
    $(this.addRecipientsManuallyTarget).hide()
    $(this.addRecipientsFromLeadsTarget).hide()
    $(this.addRecipientsModalTarget).find(".modal-dialog").removeClass("modal-lg")
  }

  toggleOneRecipient(event) {
    var checked = $(event.currentTarget).prop("checked")
    var checkedRecipientsCount = 0

    this.recipientCheckboxTargets.forEach(function (checkbox) {
      if ($(checkbox).prop("checked")) {
        checkedRecipientsCount += 1
      }
    })

    $(this.recipientsSelectedCountTarget).text(`${checkedRecipientsCount} recipient${checkedRecipientsCount !== 1 ? "s" : ""} selected`)

    if (checked) {
      $(this.audienceActionsTarget).hide()
      $(this.selectedAudienceActionsTarget).show()

      if (checkedRecipientsCount === $(this.recipientCheckboxTargets).length) {
        $(this.toggleAllCheckboxTarget).prop("checked", true)
      }

      return
    }

    $(this.toggleAllCheckboxTarget).prop("checked", false)

    if (checkedRecipientsCount === 0) {
      $(this.audienceActionsTarget).show()
      $(this.selectedAudienceActionsTarget).hide()
    }
  }
}
